import { parseDate } from "flicket-ui";
import * as Yup from "yup";

export const DOBDateInputSchema = Yup.date()
  .transform((_, originalValue: any) => parseDate(originalValue))
  .typeError("Invalid date of birth");
